import axios from "axios";
import api, { API } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const fileUrl = (u) => (u && u.startsWith("/") ? `${BACKEND_URL}${u}` : u || "");

export async function uploadPublic(file, kind, onProgress) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`${API}/public/upload?kind=${kind}`, fd, {
    onUploadProgress: (e) => onProgress && onProgress(Math.round((e.loaded / (e.total || 1)) * 100)),
  });
  return data;
}

export async function uploadSchool(file, kind, onProgress) {
  return uploadAuthed(`/school/upload?kind=${kind}`, file, onProgress);
}

export async function uploadSuper(file, kind, onProgress) {
  return uploadAuthed(`/superadmin/upload?kind=${kind}`, file, onProgress);
}

async function uploadAuthed(path, file, onProgress) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(path, fd, {
    onUploadProgress: (e) => onProgress && onProgress(Math.round((e.loaded / (e.total || 1)) * 100)),
  });
  return data;
}
